import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, inject, onBeforeMount, onUnmounted, nextTick, getCurrentInstance } from 'vue'
import { emitRtDialogClosedWithoutSubmit } from '@/plugins/emitter'
import { useRealtimeTransferSend, RtSendFactoryKey } from '@/composables/useRealtimeTransferSend'


export default /*#__PURE__*/_defineComponent({
  __name: 'MedleyDialog',
  setup(__props) {

const vm = getCurrentInstance()!.proxy as any

const isMypage = ref(false)
const formatid = ref('')
const previewHtml = ref('')
const permissionType = ref(4)
const isSendedMedley = ref(false)
const fullscreenLoading = ref(false)
const clientId = ref('medley_link')
const dialogName = ref('medley_dialog')
const username = ref('')
const isAgree = ref(true)
const basicData = ref<Record<string, any>>({})
const dialogInfo = ref<Record<string, any>>({})
const medleyModalVisible = ref(false)
const medleyModalOpened = ref(false)
const pendingReshow = ref(false)
const replacingOpen = ref(false)

const pdfFormData = computed(() => {
  const fd = new FormData()
  fd.append('app_html', previewHtml.value)
  fd.append('pdf_option', 'A4')
  return fd
})

function createFilename (ext: string): string {
  const now = new Date()
  const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX ?? ''
  const dateString = vm.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
  return `${prefix}${formatid.value}${dateString}.${ext}`
}

function getPrefName (): string { return '' }
function getCityName (): string { return '' }

function openMedleyDialog (id: string, html: any, perm: number, info: Record<string, any>, bd: Record<string, any>, mypage = false) {
  isMypage.value = mypage
  formatid.value = id
  previewHtml.value = html && html.$el ? html.$el.innerHTML : ''
  permissionType.value = perm === 0 ? 4 : perm
  dialogInfo.value = info
  basicData.value = bd || {}
  clientId.value = info.clientId ?? 'medley_link'
  dialogName.value = info.dialogName ?? 'medley_dialog'
  isSendedMedley.value = false

  const formData = new FormData()
  formData.append('uuid', vm.$firebase.user.uid)
  formData.append('format_id', formatid.value)
  formData.append('dialog_name', dialogName.value)
  formData.append('permission_type', String(permissionType.value))
  formData.append('device_flg', vm.$deviceLib.isMobileDevice ? 'SP' : 'PC')
  formData.append('version', '2')
  formData.append('is_mypage', isMypage.value ? 'true' : 'false')
  formData.append('site_flag', 'r')
  formData.append('app_flag', vm.$site.appFlag)
  vm.$axios.post(vm.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })

  vm.$iterateStorage((value: any, key: string) => {
    if (key === 'basicData') username.value = `${value.lastName}_${value.firstName}`
  }, (err: any) => { if (!err) console.log('Iteration has completed') })

  if (medleyModalOpened.value) {
    pendingReshow.value = true
    replacingOpen.value = true
    medleyModalVisible.value = false
  } else {
    nextTick(() => { medleyModalVisible.value = true })
  }
}

function onMedleyModalOpened () { medleyModalOpened.value = true }

function onMedleyModalClosed () {
  medleyModalOpened.value = false
  if (pendingReshow.value) {
    pendingReshow.value = false
    replacingOpen.value = false
    nextTick(() => { medleyModalVisible.value = true })
  }
}

function closeMedleyDialog () { medleyModalVisible.value = false }

function handleBeforeClose () {
  if (replacingOpen.value) return
  if (!isSendedMedley.value) {
    vm.$eventHub.$emit('update_rt_condition', clientId.value, permissionType.value)
    emitRtDialogClosedWithoutSubmit()
  }
}

const rtSendFactory = inject(RtSendFactoryKey, useRealtimeTransferSend)
const { sendMedleyConsult } = rtSendFactory({
  vm,
  isAgree,
  isRealtimeTransferCommonSended: isSendedMedley,
  fullscreenLoading,
  pdfFormData,
  formatid,
  username,
  clientId,
  dialogName,
  permissionType,
  basicData,
  dialogInfo,
  isMypage,
  createFilename,
  getPrefName,
  getCityName
})

vm.$iterateStorage((value: any, key: string) => {
  if (key === 'basicData') username.value = `${value.lastName}_${value.firstName}`
}, (err: any) => { if (!err) console.log('Iteration has completed') })

let mittGVPopupHandler: ((argList: unknown) => void) | undefined

onBeforeMount(() => {
  mittGVPopupHandler = (argList: unknown) => {
    if (Array.isArray(argList)) openMedleyDialog.apply(null, argList as any)
  }
  vm.$emitter.on('open-medley-dialog', mittGVPopupHandler)
  vm.$emitter.on('send-medley-consult', sendMedleyConsult)
  vm.$eventHub.$on('popstate', closeMedleyDialog)
})

onUnmounted(() => {
  vm.$emitter.off('open-medley-dialog', mittGVPopupHandler)
  vm.$emitter.off('send-medley-consult', sendMedleyConsult)
  vm.$eventHub.$off('popstate', closeMedleyDialog)
})

return { __sfc: true,vm, isMypage, formatid, previewHtml, permissionType, isSendedMedley, fullscreenLoading, clientId, dialogName, username, isAgree, basicData, dialogInfo, medleyModalVisible, medleyModalOpened, pendingReshow, replacingOpen, pdfFormData, createFilename, getPrefName, getCityName, openMedleyDialog, onMedleyModalOpened, onMedleyModalClosed, closeMedleyDialog, handleBeforeClose, rtSendFactory, sendMedleyConsult, mittGVPopupHandler }
}

})